import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { memo } from "react";

const Row = (props: {
  row: any;
  onToggle: (id: any, checked: boolean) => void;
}) => {
  const { row, onToggle } = props;

  return (
    <>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell id={`PGXLisSetting_${row.id}`} scope="row">
          <span className="px-2">{row?.actionDescription}</span>
        </TableCell>
        <TableCell>
          <div className="d-flex justify-content-center">
            <div className="form-check form-switch m-0 ">
              <input
                id={`PGXLisSetting_`}
                className="form-check-input cursor-pointer"
                type="checkbox"
                role="switch"
                name="isOn"
                checked={row?.isOn}
                onChange={(event: any) =>
                  onToggle(row.id, event.target.checked)
                }
              />
            </div>
          </div>
        </TableCell>
      </TableRow>
    </>
  );
};

export default memo(Row);
